module.exports = __webpack_public_path__ + "static/media/frieddrumstick.e5f993f6.webp";